export default __webpack_public_path__ + "static/media/top-plaque.056983e2.gif";